import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const GET_ASSIGN_SPECIALIST_LIST = 'GET_ASSIGN_SPECIALIST_LIST';
export const GET_ASSIGN_SPECIALIST_LIST_SUCCESS =
  'GET_ASSIGN_SPECIALIST_LIST_SUCCESS';
export const GET_ASSIGN_SPECIALIST_LIST_FAILURE =
  'GET_ASSIGN_SPECIALIST_LIST_FAILURE';

// Action Creators
export const fetchGetAssignSpecialistList = () => ({
  type: GET_ASSIGN_SPECIALIST_LIST,
});

export const fetchGetAssignSpecialistListSuccess = (data) => ({
  type: GET_ASSIGN_SPECIALIST_LIST_SUCCESS,
  payload: data,
});

export const fetchGetAssignSpecialistListFailure = (error) => ({
  type: GET_ASSIGN_SPECIALIST_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getAssignSpecialistListProviderCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetAssignSpecialistList(data, external));
    try {
      const response = await getMethodWithToken(
        url.assignSpecialistList +
          '?appointment_id=' +
          external?.orderId +
          '&service_id=' +
          external?.serviceId,
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetAssignSpecialistListSuccess(response.data));
        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetAssignSpecialistListFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetAssignSpecialistListFailure(error.message));
    }
  };
};
